"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Customer = _interopRequireDefault(require("../model/Customer"));
var _Message = _interopRequireDefault(require("../model/Message"));
var _User = _interopRequireDefault(require("../model/User"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* User service.
* @module api/UserApi
* @version 3.0
*/
var UserApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new UserApi. 
  * @alias module:api/UserApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function UserApi(apiClient) {
    _classCallCheck(this, UserApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Get the User's details.
   * Get the User’s Details.<br>The details held under a User are things like the language preferences, theme as well as the Registration Details.<br>This API can be used to check if the User has been ‘locked’ – i.e they have tried to log in with an incorrect password multiple times, or if the User currently has an OTP (Auth Code) currently against them.<br>
   * @param {Number} userId User ID
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/User} and HTTP response
   */
  return _createClass(UserApi, [{
    key: "getUserWithHttpInfo",
    value: function getUserWithHttpInfo(userId) {
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getUser");
      }
      var pathParams = {
        'userId': userId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _User["default"];
      return this.apiClient.callApi('/users/{userId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get the User's details.
     * Get the User’s Details.<br>The details held under a User are things like the language preferences, theme as well as the Registration Details.<br>This API can be used to check if the User has been ‘locked’ – i.e they have tried to log in with an incorrect password multiple times, or if the User currently has an OTP (Auth Code) currently against them.<br>
     * @param {Number} userId User ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/User}
     */
  }, {
    key: "getUser",
    value: function getUser(userId) {
      return this.getUserWithHttpInfo(userId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get the Customer(s) owned or managed by this user
     * Get a list of Customers owned or managed by this User.<br>Filtering can be applied by passing in a line identifier – usually a Mobile Number, or other configured Legacy ID as a parameter<br>
     * @param {Number} userId User ID
     * @param {Object} opts Optional parameters
     * @param {String} [lineIdentifier] LineIdentifier
     * @param {String} [legacyIdentifier] LegacyIdentifier
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Customer>} and HTTP response
     */
  }, {
    key: "getUserCustomersWithHttpInfo",
    value: function getUserCustomersWithHttpInfo(userId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getUserCustomers");
      }
      var pathParams = {
        'userId': userId
      };
      var queryParams = {
        'lineIdentifier': opts['lineIdentifier'],
        'legacyIdentifier': opts['legacyIdentifier']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Customer["default"]];
      return this.apiClient.callApi('/users/{userId}/customers', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get the Customer(s) owned or managed by this user
     * Get a list of Customers owned or managed by this User.<br>Filtering can be applied by passing in a line identifier – usually a Mobile Number, or other configured Legacy ID as a parameter<br>
     * @param {Number} userId User ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.lineIdentifier LineIdentifier
     * @param {String} opts.legacyIdentifier LegacyIdentifier
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Customer>}
     */
  }, {
    key: "getUserCustomers",
    value: function getUserCustomers(userId, opts) {
      return this.getUserCustomersWithHttpInfo(userId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Add/Modify user details
     * Add/Modify user details.<br>Users are considered as 'on-line' users and must have a username + password.<br>Users belong to Customers. <br>A Customer have multiple Users.<br><br>Use this API for modifying everything but the user's password.
     * @param {Number} userId User ID
     * @param {module:model/User} user User Details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/User} and HTTP response
     */
  }, {
    key: "modifyUserWithHttpInfo",
    value: function modifyUserWithHttpInfo(userId, user) {
      var postBody = user;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling modifyUser");
      }
      // verify the required parameter 'user' is set
      if (user === undefined || user === null) {
        throw new Error("Missing the required parameter 'user' when calling modifyUser");
      }
      var pathParams = {
        'userId': userId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _User["default"];
      return this.apiClient.callApi('/users/{userId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Add/Modify user details
     * Add/Modify user details.<br>Users are considered as 'on-line' users and must have a username + password.<br>Users belong to Customers. <br>A Customer have multiple Users.<br><br>Use this API for modifying everything but the user's password.
     * @param {Number} userId User ID
     * @param {module:model/User} user User Details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/User}
     */
  }, {
    key: "modifyUser",
    value: function modifyUser(userId, user) {
      return this.modifyUserWithHttpInfo(userId, user).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modify a User's password
     * Modify User password.<br>Use this API for modifying the password. It is expected that the password string sent through is Base64 encoded before being put into the body of the request.<br>
     * @param {Number} userId User ID
     * @param {String} body Password
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Boolean} and HTTP response
     */
  }, {
    key: "modifyUserPasswordWithHttpInfo",
    value: function modifyUserPasswordWithHttpInfo(userId, body) {
      var postBody = body;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling modifyUserPassword");
      }
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling modifyUserPassword");
      }
      var pathParams = {
        'userId': userId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = 'Boolean';
      return this.apiClient.callApi('/users/{userId}/password', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modify a User's password
     * Modify User password.<br>Use this API for modifying the password. It is expected that the password string sent through is Base64 encoded before being put into the body of the request.<br>
     * @param {Number} userId User ID
     * @param {String} body Password
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Boolean}
     */
  }, {
    key: "modifyUserPassword",
    value: function modifyUserPassword(userId, body) {
      return this.modifyUserPasswordWithHttpInfo(userId, body).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();